import { render } from "./GotifyManual.vue?vue&type=template&id=5ceea0ac"
import script from "./GotifyManual.vue?vue&type=script&lang=js"
export * from "./GotifyManual.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__